import { atomWithStorage } from "jotai/utils";

export const tripAtom = atomWithStorage("tripAtom", {});
